import Vue from "vue";
import CognitoAuth from "./cognito";
import config from "@/config";

Vue.use(new CognitoAuth(), config);

export default new CognitoAuth();